import { connection, deleteRecord, findRecord, insertRecord, transferMoney, updateRecord, updateWalletsForTransfer, sortArray } from "./services";
import { toJalaali } from "jalaali-js";

async function getInfo(userId = -1) {
  let walletId;
  if (userId != -1) {
    walletId = await findRecord("wallets", {
      conditions: `uid/=/${userId}`,
      fields: "id",
    });
    if (walletId.length == 0) return false;
  }
  let info = {
    transactionList: [
      /*
        {
          id,
          price, 
          time, 
          date, 
          type,
          type == 2 => fromUser:{
            fullname,
            mobile,
            walletId,
            id

          }, toUser:{
            fullname,
            mobile,
            walletId,
            id
          },
          type != 2 => fullname, walletId,id
        } 
      */
    ],
  };
  if (userId == -1)
    info = {
      ...info,
      walletCounts: 0,
      totalMoney: 0,
      totalDeposite: 0,
      totalWithdraw: 0,
      userList: [
        /* 
        {
          id,
          fullname,
          mobile,
          walletId,
        }
      */
      ],
    };

  let data;
  if (userId == -1) {
    // userList
    data = await findRecord("wallets", {
      tbl_name: "users",
      fields: "wallets.id, wallets.uid, users.fname, users.lname, users.mobile",
      conditions: `wallets.type/!=/1@@users.mainstatus/!=/2`,
    });
    info.userList = data.map((value) => {
      return {
        id: value.uid,
        fullname: value.fname + " " + value.lname,
        mobile: value.mobile,
        walletId: value.id,
      };
    });

    // walletCounts
    data = await findRecord("wallets", {
      fields: "SUM(current_inventory) as totalMoney",
    });
    info.totalMoney = parseInt(data[0].totalMoney);

    // totalMoney
    data = await findRecord("wallets", {
      fields: "COUNT(id) as walletCounts",
      conditions: "id/!=/1@@main_status/=/0",
    });
    info.walletCounts = parseInt(data[0].walletCounts);
  }

  // transactionList & totalWithdraw
  if (userId == -1) {
    data = await connection("fullwallettransaction", {
      conditions: "type/in/0,2,3",
    });
    data = data.data;
  } else {
    data = await connection("fullwallettransaction", {
      conditions: `type/in/2,3@@from_wallet_id/=/${walletId[0].id}`,
    });
    let temp = await connection("fullwallettransaction", {
      conditions: `type/in/0,2@@to_wallet_id/=/${walletId[0].id}`,
    });
    data = data.data.concat(temp.data);
  }
  data = sortArray(data, "mtm");
  info.transactionList = data.map((value) => {
    let res = {
      id: value.id,
      type: value.type == 0 ? "1" : value.type,
      price: value.amount,
      timestamp: value.mtm != "" ? parseInt(value.mtm) * 1000 : new Date().getTime(),
      date: "",
      time: "",
    };
    try {
      let date = new Date(res.timestamp);
      let perDate = toJalaali(date);
      res.date = `${perDate.jy}/${perDate.jm}/${perDate.jd}`;
      res.time = `${(date.getHours() < 10 ? "0" : "") + date.getHours()}:${(date.getMinutes() < 10 ? "0" : "") + date.getMinutes()}`;
    } catch (err) {}
    if (value.type == 2) {
      res.fromUser = {
        id: 0,
        fullname: ``,
        mobile: "",
        walletId: 0,
      };
      res.toUser = {
        id: 0,
        fullname: ``,
        mobile: "",
        walletId: 0,
      };
      if (value.from_user) {
        res.fromUser = {
          id: value.from_user.id,
          fullname: `${value.from_user.fname} ${value.from_user.lname}`,
          mobile: value.from_user.mobile,
          walletId: value.from_wallet_id,
        };
      }
      if (value.to_user) {
        res.toUser = {
          id: value.to_user.id,
          fullname: `${value.to_user.fname} ${value.to_user.lname}`,
          mobile: value.to_user.mobile,
          walletId: value.to_wallet_id,
        };
      }
    } else if (value.type == 3) {
      if (userId == -1) info.totalWithdraw += parseInt(value.amount);
      res.user = {
        id: 0,
        fullname: ``,
        mobile: "",
        walletId: 0,
      };
      if (value.from_user) {
        res.user = {
          id: value.from_user.id,
          fullname: `${value.from_user.fname} ${value.from_user.lname}`,
          mobile: value.from_user.mobile,
          walletId: value.from_wallet_id,
        };
      }
    } else {
      if (userId == -1) info.totalDeposite += parseInt(value.amount);
      res.user = {
        id: 0,
        fullname: ``,
        mobile: "",
        walletId: 0,
      };
      if (value.to_user) {
        res.user = {
          id: value.to_user.id,
          fullname: `${value.to_user.fname} ${value.to_user.lname}`,
          mobile: value.to_user.mobile,
          walletId: value.to_wallet_id,
        };
      }
    }
    return res;
  });
  return info;
}

// transactionId != -1 when this function is for edit.
// insert : wi - price
// edit : wi price ti
async function checkInventory(walletId, price, transactionId = -1, onSecondWallet = false) {
  let wallet = await findRecord("wallets", { conditions: `id/=/${walletId}` });
  if (wallet.length == 0) return false;
  let inventory = parseInt(wallet[0].current_inventory);

  if (transactionId != -1) {
    let transaction = await findRecord("wallets_transactions", {
      fields: "amount",
      conditions: `id/=/${transactionId}`,
    });
    let x = parseInt(transaction[0].amount);
    if (onSecondWallet) x *= -1;
    inventory += x;
  }
  return inventory >= price;
}

async function deleteTransaction(transactionId) {
  let res = await findRecord("wallets_transactions", {
    conditions: `id/=/${transactionId}`,
    fields: "amount, from_wallet_id, to_wallet_id",
  });
  if (res.length == 0) return false;
  let [price, fromWalletId, toWalletId] = [res[0].amount, res[0].to_wallet_id, res[0].from_wallet_id];
  res = await deleteRecord("wallets_transactions", `id/=/${transactionId}`);
  if (res.status != 1) return false;
  return await updateWalletsForTransfer(fromWalletId, toWalletId, price, true);
}

/*
data ={
  price,
  type,
  mtm,
  type == 2 => fromWalletId, toWalletId,
  type != 2 => walletId,
}
*/
// برداشت:3 - تراکنش داخلی :2 - واریز :1
async function insertTransaction(data) {
  let master = await findRecord("wallets", {
    fields: "id",
    conditions: "type/=/1",
  });
  let fromWalletId, toWalletId;
  if (data.type == 1) {
    [fromWalletId, toWalletId] = [master[0].id, data.walletId];
    data.type = 0;
  } else if (data.type == 2) {
    [fromWalletId, toWalletId] = [data.fromWalletId, data.toWalletId];
  } else {
    [fromWalletId, toWalletId] = [data.walletId, master[0].id];
  }
  if (data.type != 0 && !checkInventory(fromWalletId, data.price)) return false;
  return await transferMoney(fromWalletId, toWalletId, data.type, data.price, 0, data.mtm);
}

/*
data ={
  price,
  type,
  prevType
  mtm,
  type == 2 => fromWalletId, toWalletId,
  type != 2 => walletId,
}
*/
async function updateTransaction(transactionId, data) {
  let { type, pervType, price, mtm } = data,
    res,
    fromWalletId,
    toWalletId;
  type = type == 1 ? 0 : type;

  let master = await findRecord("wallets", {
    conditions: `type/=/1`,
    fields: "id",
  });

  if (pervType != type) {
    res = await deleteTransaction(transactionId, pervType);
    if (!res) return false;
    res = await insertTransaction(data);
    return res;
  }

  res = await findRecord("wallets_transactions", {
    conditions: `id/=/${transactionId}@@type/=/${pervType}`,
    fields: "amount, from_wallet_id, to_wallet_id",
  });
  if (res.length == 0) return false;
  let x = data.walletId ? data.walletId : data.fromWalletId;
  if (type != 0) {
    if (res[0].from_wallet_id == x) {
      if (!checkInventory(x, price, transactionId)) return false;
    } else if (res[0].to_wallet_id == x) {
      if (!checkInventory(x, price, transactionId, true)) return false;
    } else {
      if (!checkInventory(x, price)) return false;
    }
  }

  [fromWalletId, toWalletId] = [res[0].from_wallet_id, res[0].to_wallet_id];
  res = await updateWalletsForTransfer(
    toWalletId,
    fromWalletId,
    res[0].amount,
    true
  );
  if (!res) return false;
  if (type == 0) {
    [fromWalletId, toWalletId] = [master[0].id, data.walletId];
  } else if (type == 2) {
    [fromWalletId, toWalletId] = [data.fromWalletId, data.toWalletId];
  } else {
    [fromWalletId, toWalletId] = [data.walletId, master[0].id];
  }
  res = await updateRecord("wallets_transactions", {
    keyvalues: {
      amount: price,
      from_wallet_id: fromWalletId,
      to_wallet_id: toWalletId,
      type,
      mtm,
    },
    conditions: `id/=/${transactionId}`,
  });
  if (res.status != 1) return false;
  return await updateWalletsForTransfer(fromWalletId, toWalletId, price);
}

export { getInfo, checkInventory, insertTransaction, updateTransaction, deleteTransaction };
